/**
 * Returns the URL only when it parses as http(s); otherwise ''. Blocks unsafe
 * hrefs (e.g. `javascript:`, `data:`) from a misconfigured runtime-config value
 * before it reaches an <a href>.
 */
export function safeHttpUrl(url: string | undefined | null): string {
  if (!url) return '';
  try {
    const parsed = new URL(url);
    // Return the normalized href (not the raw input) so the value rendered into
    // the href is exactly what was validated.
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
      ? parsed.href
      : '';
  } catch {
    return '';
  }
}
